import { observer } from "mobx-react-lite";
import React from "react";
import { getLimitPer, showDashIfZero } from "../../utils/functions";

const MoneyValueContainer = ({
  title,
  amount,
  amtPercentage,
  infoLogo,
  hasPadding,
  addDash,
  TooltipContent,
  tipClass,
  unitType,
}) => {
  return (
    <div
      className={
        !hasPadding
          ? "instr_money_value_container_out "
          : "instr_money_value_container_out "
      }
    >
      <div className="title_container">
        <h2
          className={
            hasPadding !== undefined ? "large_font  title" : "small_font title"
          }
        >
          {title}
        </h2>
        {infoLogo !== undefined && (
          <div className="img_wrapper">
            <img className="logo" src={infoLogo} alt="logo" />
            <div className={`tool ${tipClass}`}>{TooltipContent}</div>
          </div>
        )}{" "}
      </div>
      <h2
        className={
          title === "IRR" ? "amount amount_color_green" : "amount color_light_b"
        }
      >
        {addDash ? showDashIfZero(amount) : amount}{" "}
        <span className="unitFont">
          {unitType !== "lacs" ? unitType : "L"}{" "}
        </span>
        {amtPercentage !== undefined && (
          <span
            className={
              amtPercentage?.includes("-")
                ? "amtPercentage red"
                : "amtPercentage green"
            }
          >
            {" "}
            {amtPercentage ? getLimitPer(amtPercentage) + "%" : "-"}
          </span>
        )}
      </h2>
    </div>
  );
};

export default observer(MoneyValueContainer);
